export default "data:image/gif;base64,R0lGODlhEgAMAPEAAACqAP8AAP//AAAAACH5BAAAAAAALAAAAAASAAwAAAIXlI+py+2vgJy02ouz3jb4D4biSJbmKRYAOw=="